(function () {
    const STYLE_MARK = 'data-bnpl-payment-terms';

    const HOST_CSS = `
                :host {
                    display: block !important;
                    margin: 0 !important;
                    width: 100% !important;
                    max-width: 100% !important;
                    background: #F6F9FF;
                    border-radius: 3px !important;
                    padding: 12px 14px 12px 20px !important;
                }

                :host * {
                    font-family: Inter !important;
                }

                :host div:not(:empty) p {
                    display: flex !important;
                    gap: 10px !important;
                    flex-wrap: wrap !important;
                    align-items: center !important;
                    justify-content: space-between !important;
                }

                :host div:not(:empty) p #shopify-installments-content {
                    font-size: 16px !important;
                    font-weight: 500;
                    letter-spacing: 0;
                    flex: 1;
                    min-width: 280px;
                    padding: 0 !important;
                    color: var(--color-text, #252525);
                }

                :host div:not(:empty) p #shopify-installments-content .text-purple-primary{
                    color: rgb(84 51 235/var(--tw-text-opacity)) !important;
                }

                :host div:not(:empty) p #shopify-installments-content .font-bold {
                    font-weight: 700 !important;
                }

                img {
                    width: 45px !important;
                    height: auto !important;
                    object-fit: contain !important;
                }
          
                :host #prequalAmountContainer {
                    display: none !important;
                }

                :host #shopify-installments-cta {
                    color: var(--color-text, #252525) !important;
                    min-width: 110px !important;
                    min-height: 25px !important;
                    display: flex !important;
                    align-items: center !important;
                    text-wrap: nowrap !important;
                    justify-content: center !important;
                    padding: 0 10px !important;
                    font-weight: 600 !important;
                    font-size: 13px !important;
                    line-height: normal !important;
                    letter-spacing: 0 !important;
                    text-decoration: none !important;
                    border: 1px solid var(--color-text, #252525) !important;
                    border-radius: 50px !important;
                    text-transform: capitalize !important;
                    background: transparent !important;
                    cursor: pointer !important;
                    margin: 0 !important;
                }
          
                :host #shopify-installments-cta:hover {
                    background: #ffffff !important;
                }
          
                @media (min-width: 750px) {
                    :host {
                        border-radius: 8px !important;
                        padding: 14px 14px 9px 20px !important;
                    }

                    :host #shopify-installments-cta {
                        min-height: 30px !important;
                        font-size: 12px !important;
                    }
                }
        `;

    function injectShadowStyles(element) {
        const shadowRoot = element.shadowRoot;
        if (!shadowRoot) return false;
        if (shadowRoot.querySelector(`style[${STYLE_MARK}]`)) return true;
        const style = document.createElement('style');
        style.setAttribute(STYLE_MARK, 'true');
        style.textContent = HOST_CSS;
        shadowRoot.appendChild(style);
        return true;
    }

    function applyFallbackLayout(element) {
        if (element.shadowRoot) return;
        if (element.dataset.bnplFallbackWrapped === 'true') return;
        const wrapper = document.createElement('div');
        wrapper.className = 'payment-terms-wrapper';
        wrapper.style.cssText = 'display: flex; align-items: center; justify-content: space-between; gap: 37px; padding: 12px 10px; background: var(--color-light-blue, #F6F9FF); border-radius: 3px; width: 100%;';

        const parent = element.parentNode;
        if (!parent) return;
        parent.insertBefore(wrapper, element);
        wrapper.appendChild(element);

        element.style.display = 'block';
        element.style.margin = '0';
        element.style.width = '100%';
        element.style.maxWidth = '100%';
        element.style.background = 'var(--color-light-blue, #F6F9FF)';
        element.style.borderRadius = '3px';
        element.style.boxSizing = 'border-box';

        const form = element.closest('form');
        if (form) {
            form.style.width = '100%';
            form.style.maxWidth = '100%';
        }
        element.dataset.bnplFallbackWrapped = 'true';
    }

    function stylePaymentTerms() {
        document.querySelectorAll('shopify-payment-terms').forEach((element) => {
            if (injectShadowStyles(element)) {
                element.dataset.styled = 'true';
                return;
            }
            applyFallbackLayout(element);
        });
    }

    window.styleShopifyPaymentTerms = stylePaymentTerms;

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', stylePaymentTerms);
    } else {
        stylePaymentTerms();
    }

    setTimeout(stylePaymentTerms, 500);
    setTimeout(stylePaymentTerms, 1000);
    setTimeout(stylePaymentTerms, 2000);

    const observer = new MutationObserver(() => {
        stylePaymentTerms();
    });

    observer.observe(document.body, {
        childList: true,
        subtree: true
    });
})();
